import type { OrderStatus } from "@pufimi/shared";

// Shared React Query keys so the auth gate, the dashboard, and the login flow
// all read/invalidate the same cache entry.
export const ADMIN_ME_QUERY_KEY = ["admin", "me"] as const;

// Dashboard stats key (#245): the whole overview is one cache entry.
export const adminStatsQueryKey = () => ["admin", "stats"] as const;

// Order-list key namespaced by the active status filter + page, so switching the
// filter or page is a distinct cache entry (and refetch) rather than clobbering
// another view of the list (#239, paged in #245).
export const adminOrdersQueryKey = (status?: OrderStatus, page = 1) =>
  ["admin", "orders", { status: status ?? null, page }] as const;

// Order-detail key by id.
export const adminOrderQueryKey = (orderId: string) => ["admin", "order", orderId] as const;

// Settings key (#240): the whole registry is one cache entry — a PUT invalidates
// it so the form re-reads the persisted values.
export const adminSettingsQueryKey = () => ["admin", "settings"] as const;

// Feature-flags key (#241): all flags are one cache entry — a toggle invalidates
// it so the list re-reads the persisted state + audit columns.
export const adminFeatureFlagsQueryKey = () => ["admin", "feature-flags"] as const;

// Katalog key (#404): the whole catalogue (types + variants) is one cache entry —
// a type/variant edit invalidates it so the tab re-reads the persisted state.
export const adminCatalogQueryKey = () => ["admin", "catalog"] as const;

// Legal-documents keys (#305): the section index is one cache entry; each document's
// editor state is keyed by slug. A save-draft / publish invalidates both so the list
// badge + the editor buffer re-read the persisted state.
export const adminLegalDocumentsQueryKey = () => ["admin", "legal-documents"] as const;
export const adminLegalDocumentQueryKey = (slug: string) =>
  ["admin", "legal-document", slug] as const;
